import { useContentEditor } from 'common/components/ContentEditor/hooks/useContentEditor';
import { toggleList } from 'common/components/ContentEditor/utils/editorHelpers';

import { IToolbarButtonProps, ToolbarButton } from './ToolbarButton';

interface IProps extends IToolbarButtonProps {
    typeList: string;
}

export const ToolbarList = ({ typeList, ...props }: IProps) => {
    const editor = useContentEditor();

    return (
        <ToolbarButton
            active={editor.api.some({ match: { type: typeList } })}
            onMouseDown={(event) => {
                event.preventDefault();

                if (!editor.selection) return;

                toggleList(editor, typeList);
            }}
            {...props}
        />
    );
};
